const ChangePassword = {

    // PAGE HEADER
    "tagline": "पासवर्ड बदलें",

    // FIELDS
    "old_pass": "पुराना पासवर्ड",
    "new_pass": "नया पासवर्ड",
    "confirm_pass": "पासवर्ड की पुष्टि करें",

    // TOAST
    "success_add": "पासवर्ड सफलतापूर्वक बदल दिया गया!!..",
    "server_error": "सर्वर त्रुटि!!..",
    "wrong": "कुछ गलत हो गया!!..",

    // ERROR
    "error_old_pass": "कृपया पुराना पासवर्ड दर्ज करें",
    "error_new_pass": "कृपया नया पासवर्ड दर्ज करें",
    "error_confirm_pass": "कृपया पुष्टि पासवर्ड दर्ज करें",
    "error_pass_match": "पुष्टि पासवर्ड मेल नहीं खा रहा है",

}

export default ChangePassword;